<!--Une seule boîte pour les deux gestes (SU #120249) : choix de la corbeille pour l’envoi, simple
    confirmation pour le retrait.-->
<val-boite-dialogue-generique #boiteDialogue
                              [titre]="titre | transloco"
                              class="val-corbeille-ged-factures-achat"
                              [validerDesactive]="!retrait && corbeilleSelectionnee === null"
                              (validerClick)="Valider ()"
                              (annulerClick)="Annuler ()">
  <div contenu class="val-corbeille-ged-factures-achat-contenu">
    <val-simple-panel>
      @if (!retrait)
      {
        <val-controle-conteneur [label]="'achat.corbeille-ged.corbeille' | transloco"
                                [tailleLabel]="tailleLabels">
          <kendo-combobox class="val-kd-combobox"
                          size="small"
                          [clearButton]="false"
                          [popupSettings]="{appendTo: 'component', popupClass: 'val-kd-combo-popup'}"
                          [data]="corbeillesGed"
                          textField="libelle"
                          valueField="identifiant"
                          [(value)]="corbeilleSelectionnee">
          </kendo-combobox>
        </val-controle-conteneur>
        <div style="height: 4px;"></div>
        <div class="val-corbeille-ged-factures-achat-selection">
          {{ 'achat.commun.factures-selectionnees' | transloco: { nombre: nombreFacturesSelectionnees } }}
        </div>
      }
      @else
      {
        <div class="val-corbeille-ged-factures-achat-selection">
          {{ 'achat.corbeille-ged.confirmation-retrait' | transloco: { nombre: nombreFacturesSelectionnees } }}
        </div>
      }
    </val-simple-panel>
  </div>
</val-boite-dialogue-generique>
<val-boite-dialogue-messages #boiteDialogueMessages></val-boite-dialogue-messages>
